import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

export const learningMapImport = (params) => {
  return apiBaseUrl.post('/aiassist/learning/map/import', params);
};

export const learningMapPage = (params) => {
  return apiBaseUrl.post(`/aiassist/learning/map/page?limit=${params.limit}&current=${params.current}`, params);
};

export const getLearningMapDetail = (id) => {
  return apiBaseUrl.get(`/aiassist/learning/map/${id}/detail`);
};

export const deleteLearningMap = (id) => {
  return apiBaseUrl.delete(`/aiassist/learning/map/${id}`);
};

export const learningMapSetEnv = (params) => {
  return apiBaseUrl.post('/aiassist/learning/map/set/env', params);
};

export const saveLearningMapPeriod = (id, periodid, data) => {
  return apiBaseUrl.post(`/aiassist/learning/map/${id}/period/${periodid}/save`, data);
};

export const exportLearningMap = (id) => {
  return apiBaseUrl.post(`/aiassist/learning/map/${id}/export`);
};

export const learningMapClear = (mapId) => {
  return apiBaseUrl.post(`/aiassist/learning/map/${mapId}/clear`);
};
